import { Salesperson } from '~/models'
import { $axios } from '~/utils/api'

const END_POINT = '/salesperson'

const getSalespeople = (id: number, type: 'lot' | 'plan'): Promise<Array<Salesperson>> => $axios.$get(`${END_POINT}?${type}_id=${id}`)

export { getSalespeople }
